<template>
  <div class="flex justify-center">
    <div class="w-1/2 flex justify-center">
      <div
        class="reactive-button-wrapper"
        @mousemove="handleMouseMove"
        @mouseenter="isHovering = true"
        @mouseleave="handleMouseLeave"
        ref="buttonRef"
        :style="buttonTransform"
      >
        <div class="button-glow" :style="glowPosition"></div>
        <a href="mailto:info@herogrow.net">
          <el-button class="contact-button w-[300px] mx-auto" size="large" plain>
            Contact Us
          </el-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

const buttonRef = ref(null);
const isHovering = ref(false);
const mouseX = ref(0.5);
const mouseY = ref(0.5);

const handleMouseMove = (e) => {
  if (!buttonRef.value) return;
  const rect = buttonRef.value.getBoundingClientRect();
  mouseX.value = (e.clientX - rect.left) / rect.width;
  mouseY.value = (e.clientY - rect.top) / rect.height;
};

const handleMouseLeave = () => {
  isHovering.value = false;
  // Don't reset position - let it fade out where it is
};

// 3D tilt effect based on mouse position
const buttonTransform = computed(() => {
  if (!isHovering.value) return {};
  
  const tiltX = (mouseY.value - 0.5) * -10; // Max 10deg tilt
  const tiltY = (mouseX.value - 0.5) * 10;
  
  return {
    transform: `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.02)`,
  };
});

// Gradient glow that follows mouse
const glowPosition = computed(() => ({
  background: `radial-gradient(circle at ${mouseX.value * 100}% ${mouseY.value * 100}%, rgba(255, 165, 0, 0.3), transparent 60%)`,
  opacity: isHovering.value ? 1 : 0,
}));
</script>

<style scoped>
.reactive-button-wrapper {
  position: relative;
  display: inline-block;
  border-radius: 8px;
  transition: all 0.6s cubic-bezier(0.25, 0, 0.25, 1);
  transform-style: preserve-3d;
}

.button-glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  transition: opacity 1.5s ease, background 2s ease;
  z-index: 0;
  border-radius: 8px;
}

.contact-button {
  background-color: hsla(273, 100%, 34%, 0.429);
  color: #ffffff;
  transition-property: all;
  transition-duration: 0.5s;
  height: 60px;
  position: relative;
  z-index: 1;
}

/* Style for the contact button when hovered */
.contact-button:hover {
  background-color: #a474ff;
  /* Purple background */
  color: #ffffff;
  /* White text */
}
</style>
